module.exports = __webpack_public_path__ + "img/logoBlack.db771ace.png";